import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { fadeIn } from '../../utils/animations';

const EducationalPageContainer = styled.div` /* Renamed */
  width: 100%;
  padding: 2rem; /* Added page padding */
  background-color: ${(props) => props.theme.colors.background}; /* Updated */
  color: ${(props) => props.theme.colors.text}; /* Updated */
  display: flex;
  flex-direction: column;
  align-items: center; /* Center content items */
  gap: 2rem; /* Spacing between items */
  opacity: 0; /* Initial state for page load animation */
  animation: ${fadeIn} 0.5s ease-out forwards; /* Page load animation */
`;

const ItemContainer = styled.div`
  display: flex;
  width: 80%; /* Adjusted width */
  max-width: 900px; /* Max width for cards */
  /* margin: 1rem; Removed, using gap on parent */
  background-color: ${(props) => props.theme.colors.surface}; /* Updated */
  border-radius: ${(props) => props.theme.borderRadius}; /* Updated */
  animation: ${fadeIn} 0.5s ease-in-out;
  animation-fill-mode: both;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); /* Updated shadow */
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out; /* Updated transition */
  height: auto;
  /* max-height: 400px; Removed or adjust based on content */
  overflow: hidden; 

  @media (max-width: 768px) {
    flex-direction: column; /* Stack image and content */
    width: 90%; /* Wider on mobile */
  }

  &:hover {
    transform: translateY(-4px); /* Updated hover effect */
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12); /* Updated hover shadow */
  }
`;

const Image = styled.img`
  width: 40%; 
  height: 100%; 
  min-height: 280px; /* Ensure image has some min height */
  object-fit: cover;

  @media (max-width: 768px) {
    width: 100%; /* Full width when stacked */
    height: 200px; /* Adjust height for stacked layout */
    min-height: auto;
  }
`;

const ContentContainer = styled.div`
  flex-direction: column;
  justify-content: center; 
  display: flex;
  align-self: stretch; 
  padding: 2rem; /* Increased padding */
  width: 60%; 

  @media (max-width: 768px) {
    width: 100%; /* Full width when stacked */
    padding: 1.5rem;
  }
`;

const Title = styled.h2`
  font-family: ${(props) => props.theme.fontFamilies.primary}; /* Updated */
  font-size: ${(props) => props.theme.fontSizes.h2}; /* Updated */
  color: ${(props) => props.theme.colors.primary}; /* Updated */
  line-height: ${(props) => props.theme.lineHeights.heading}; /* Updated */
  font-weight: 600;
  margin: 0 0 1rem 0; 
 text-align: left; /* Removed dynamic align prop */
`;

const Description = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.secondary}; /* Updated */
  font-size: ${(props) => props.theme.fontSizes.body}; /* Updated */
  color: ${(props) => props.theme.colors.text}; /* Updated */
  line-height: ${(props) => props.theme.lineHeights.body}; /* Updated */
  margin: 0;
`;

const EducationalComponent: React.FC = () => {
  const { t } = useTranslation();
  const sikhRepImgSrc = require('../../assets/7.jpg');
  return (
    <EducationalPageContainer>
      <ItemContainer>
        <Image
          src={sikhRepImgSrc}
          alt={t('educational.sikhRepresentationImageAlt') as string}
          style={{
            borderTopLeftRadius: '8px', // Match ItemContainer
            borderBottomLeftRadius: '8px', // Match ItemContainer
          }}
        />
        <ContentContainer>
          <Title>{t('educational.whoAreSikhsTitle')}</Title>
          <Description>{t('educational.whoAreSikhsDescription')}</Description>
        </ContentContainer>
      </ItemContainer>
      {/* Removed transparent Title spacer */}
    </EducationalPageContainer>
  );
}

export default React.memo(EducationalComponent);
